import { ComponentClass } from 'react';

export { ComponentClass };

import { createLazyComponent, LazyModule, LazyAction } from 'owa-bundling';
import { MailListItemExpansionProps } from './components/MailListItemExpansion';
import { FolderTagProps } from './components/FolderTag';
import renderMeetingPreviewPlaceHolder from './components/MailListItemMeetingPreviewPlaceholder';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "MailListItemExpansion", webpackPrefetch: true */ './lazyIndex')
);

// Delayed Loaded Components
export let MailListItemExpansion = createLazyComponent(lazyModule, m => m.MailListItemExpansion);
export let FolderTag = createLazyComponent(lazyModule, m => m.FolderTag);
export let MailListItemMeetingPreview = createLazyComponent(
    lazyModule,
    m => m.MailListItemMeetingPreview,
    () => renderMeetingPreviewPlaceHolder()
);
export let MailListItemMeetingInfo = createLazyComponent(
    lazyModule,
    m => m.MailListItemMeetingInfo
);

export let lazyGetFlagContextMenu = new LazyAction(lazyModule, m => m.getFlagContextMenu);
export { MailListItemExpansionProps, FolderTagProps };
export { default as getStyleSelectorAsPerUserSettings } from './utils/getStyleSelectorAsPerUserSettings';
